
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/faq",
      function () {
        return require("private-next-pages/fr/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/faq"])
      });
    }
  